import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { COMPANY } from "../mock/mock";
import { useI18n } from "../i18n/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-[#1a1a1a] border-t border-[#c5a76f]/15 text-white/70">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Logo />
          <p className="text-sm mt-6 leading-relaxed">{COMPANY.tagline}</p>
          <div className="flex gap-3 mt-6">
            <a
              href={COMPANY.social.facebook}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full border border-[#c5a76f]/40 flex items-center justify-center text-[#c5a76f] hover:bg-[#c5a76f] hover:text-black transition-colors"
              aria-label="Facebook"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href={COMPANY.social.instagram}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full border border-[#c5a76f]/40 flex items-center justify-center text-[#c5a76f] hover:bg-[#c5a76f] hover:text-black transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-5">
            {t("footer.nav")}
          </h4>
          <ul className="space-y-3 text-sm">
            {[
              [t("nav.offer"), "/stock"],
              [t("nav.sold"), "/verkocht"],
              [t("nav.financing"), "/financiering"],
              [t("nav.about"), "/over-ons"],
              [t("nav.contact"), "/contact"],
            ].map(([l, h]) => (
              <li key={h}>
                <Link to={h} className="hover:text-[#c5a76f] transition-colors">
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-5">
            {t("footer.services")}
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/wij-kopen-uw-auto" className="hover:text-[#c5a76f] transition-colors">
                {t("nav.buyYourCar")}
              </Link>
            </li>
            <li>
              <Link to="/verkoop-mijn-auto" className="hover:text-[#c5a76f] transition-colors">
                {t("nav.sellMyCar")}
              </Link>
            </li>
            <li>
              <Link to="/financiering" className="hover:text-[#c5a76f] transition-colors">
                {t("nav.financing")}
              </Link>
            </li>
            <li>
              <Link to="/over-ons#faq" className="hover:text-[#c5a76f] transition-colors">
                {t("footer.faq")}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-5">
            {t("footer.contact")}
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-[#c5a76f]" />
              <a href={`tel:${COMPANY.phone}`} className="hover:text-[#c5a76f] transition-colors">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-[#c5a76f]" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-[#c5a76f] transition-colors">
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#c5a76f]" />
              <span>
                {COMPANY.address.street}
                <br />
                {COMPANY.address.zip} {COMPANY.address.city}
                <br />
                {COMPANY.address.country}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-5 text-xs text-white/40">
          TR Premium Cars © {new Date().getFullYear()}. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
